import { SignupRoles } from '../../../enums/signup-roles.enum';

export class SignupRegistrationRequest
{
    // keeping these here in case we want to offer different tiers going forward.
    readonly siteId = 2;
    readonly subscriptionTemplateId = 3;
    readonly pricingOptionId = 3;

    role: 'selfManaged' | 'propertyManagement';
    groupName: string;
    fullName: string;
    email: string;
    password: string;
    phone: string;
    captcha: string;

    constructor(request: any) {
        // for now, forcing signupForm value to match RegistrationRequest's expected model with organization's segmentation values
        if (request && request.role !== SignupRoles.HOMEOWNER) {
            this.role = request.role === SignupRoles.PROPERTY_MANAGER ? 'propertyManagement' : 'selfManaged';
            this.fullName = request.fullName;
            this.groupName = request.groupName;
            this.email = request.email;
            this.phone = request.phone;
            this.captcha = request.captcha;

            // TODO: Shouldn't we hash this?
            this.password = request.password;
        }
    }
}
